import { Box, Typography } from "@mui/material";
import { COLORS } from "../../../ui/Theme";

const tabs = [
  {
    name: "ارزش آپشن",
    value: "option-value",
  },
  {
    name: "نسبت پوت به کال",
    value: "put-to-call",
  },
  {
    name: "نسبت آپشن به بازار",
    value: "option-to-market",
  },
];

const Tabs = ({ currentTab, setCurrentTab }) => {
  const handleChangeTabs = (tab) => {
    setCurrentTab(tab);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: 0.5,
        padding: "4px",
        bgcolor: COLORS.INPUTBG,
        borderRadius: "12px",
      }}
    >
      {tabs?.map((tab) => (
        <button
          onClick={() => handleChangeTabs(tab.value)}
          key={tab.value}
          className={`btn ${currentTab === tab.value ? "btn-blue" : "btn-softblue"
            }`}
        >
          <Typography sx={{ fontSize: "10px" }}>{tab.name}</Typography>
        </button>
      ))}
    </Box>
  );
};

export default Tabs;
